import { Link } from 'react-router-dom'
import { Button } from 'reactstrap'

const njcal = {
  copy_link: function copy_link(objectId, searchDetailId, searchData,location) {
  //console.log('njcal.copy_link', objectId, searchDetailId, searchData)

    let component = ''
    const pathName = `/custom/njcal.copy_link?eventId=${searchData}&source=${location.pathname}${location.search}`
    component = 
      <Link to={pathName} data-cy="search-results-view-button-link">
        <Button data-cy="search-results-view-button" className={searchData} color="primary" size="sm">Copy</Button>
      </Link>
 
    return component
  }
}

export default njcal
